import {Navigate, Outlet} from 'react-router-dom'
import {IS_REDIRECT_ENABLED, ROUTES} from '../helpers/constants'
import {useUserStore} from '../features/user/store'

export const PrivateRoute = () => {
    const accessToken = useUserStore(store => store.accessToken)
    
    if (IS_REDIRECT_ENABLED) {
        return <Outlet />
    }

    return accessToken ? <Outlet /> : <Navigate to={ROUTES.LOGIN} />
}
